module.exports = __webpack_public_path__ + "static/media/Logo_Business.a15a36dd.png";